define(function(require) {
	const tpl = require('./t_lov_view_documents.hbs');
	const modal_region = require('civicsUtils/modal_region');
	const ViewManager = require('civicsUtils/view_manager');
	const v_mv_view_documents = require('civicsViews/view_documents/v_mv_view_documents');
	const AvailableFeatures = require('civicsUtils/available_features');
	const ReportViewUtilities = require('civicsViews/view_documents/report_view_utilities');
	const Radio = require('backbone.radio');
  const ReportChannel = Radio.channel('reportChannel');
	const ConfirmationModal = require('civicsViews/core/confirmation/v_itv_confirmation');

	return Marionette.LayoutView.extend({
		template:tpl,
		className:'v_lov_view_documents',
		ui:{
			viewDocumentsLink:'.view-documents-link',

		},
		events:{
			'click @ui.viewDocumentsLink': 'openModal'
		},
		initialize:function(options){
			//options

			this.reportTypes = ReportViewUtilities.getReportTypes(
				options.milestoneType,
				options.applicationType,
				options.instrumentType,
				options.instrumentID,
				options.activeProfiles,
				options.modelId,
				options.useSecuredURL);

			this.modalRegion = options.modalRegion;

			var globalConfig = ViewManager.globalConfig().toJSON();
			this.hideLinkWhenEmpty = globalConfig.reports.hideLinkWhenEmpty;

			ReportChannel.on('openConfirmationModal', function(model) {
				this.openConfirmationModal(model);
			}.bind(this));

		},
		openConfirmationModal: function(model) {
			ViewManager.loading(true);
			//This timeout is needed so that the previous modal can be properly closed
			// before we attempt to open a new one
			setTimeout(function() {
				ViewManager.loading(false);
				this.modalRegion.show(new ConfirmationModal({
					title: i18n.t('CIVICS.INSTRUMENT_DETAIL.REPORTS.CONFIRMATION_MODAL_TITLE'),
					okLabel: i18n.t('CIVICS.COMMON.OK'),
					message: i18n.t('CIVICS.INSTRUMENT_DETAIL.REPORTS.CONFIRMATION_MODAL_DESCRIPTION'),
					modalRegion: this.modalRegion,
					showCancelButton: true,
					okCallback: () => {
						ReportViewUtilities.processReport(model, this.modalRegion);

					}
					}));
				this.modalRegion.showModal();

			}.bind(this),1000);


		},
		onRender:function(){
			if(!this.reportTypes || this.reportTypes.length == 0){
				if(this.hideLinkWhenEmpty) {

					this.ui.viewDocumentsLink.hide();

				}
				this.ui.viewDocumentsLink.css({
					'pointer-events':'none'
				});
				this.disabled = true;
			}
		},
		openModal:function(e){
			e.stopPropagation();
			e.preventDefault();
			if(!this.disabled){
				var modal = new v_mv_view_documents({
					reportTypes: this.reportTypes,
					modalRegion: this.modalRegion,
				});
				this.modalRegion.show(modal);
				this.modalRegion.showModal();
				//Set max height to display 10 documents at most
				var height = $(modal.ui.documentsList.children()[0]).outerHeight(true);//child height with margin
				var height2 = $(modal.ui.documentsList.children()[0]).height();//child height without margin
				var maxHeight = height*9 + height2;
				modal.ui.documentsList.css({
					'max-height':maxHeight
				});
			}
		},
		templateHelpers:function(){
			return {
				count: this.reportTypes ? this.reportTypes.length : 0,

				reportTypes: this.reportTypes
			}
		}
	})
});
